import React from 'react';
import Footer from '../components/Footer';

import gal1 from '../images/gal1.jpg';
import gal2 from '../images/gal2.jpg';
import gal3 from '../images/gal3.jpg';
import gal4 from '../images/gal4.jpg';
import gal5 from '../images/gal5.jpg';
import gal6 from '../images/gal6.jpg';

const Gallery = () => {
  const dentalImages = [
    {
      src: gal1,
      alt: 'Dental checkup',
      caption: 'Professional dental examination'
    },
    {
      src: gal2,
      alt: 'Dental cleaning',
      caption: 'Teeth cleaning and scaling'
    },
    {
      src: gal3,
      alt: 'Dental implants',
      caption: 'Advanced dental implant procedure'
    },
    {
      src: gal4,
      alt: 'Orthodontic braces',
      caption: 'Braces for perfect alignment'
    },
    {
      src: gal5,
      alt: 'Smile designing',
      caption: 'Cosmetic smile designing'
    },
    {
      src: gal6,
      alt: 'Dental crowns',
      caption: 'Zirconia crown installation'
    }
  ];

  return (
    <>
      <section className="container my-5">
        <div className="text-center mb-5">
          <h2 className="fw-bold text-primary">Our Dental Gallery</h2>
          <p className="text-muted">
            Explore our dental treatment procedures and facilities
          </p>
        </div>

        <div className="row g-4">
          {dentalImages.map((image, index) => (
            <div className="col-md-4" key={index}>
              <div className="card facility-card h-100">
                <img
                  src={image.src}
                  className="card-img-top"
                  alt={image.alt}
                  style={{ height: '200px', objectFit: 'cover' }}
                />
                
              </div>
            </div>
          ))}
        </div>
      </section>

      <style jsx>{`
        .facility-card {
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        }
        .facility-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
          transition: 0.3s ease-in-out;
        }
      `}</style>

      <Footer />
    </>
  );
};

export default Gallery;